import { useState } from 'react';

const locationFaqs = [
  {
    q: 'Where can I get PPF installed in South Windsor, CT?',
    a: 'DBN Garage is South Windsor\'s premier XPEL-certified paint protection film installer. Located in South Windsor, CT, we serve the entire Hartford County area including Manchester, Glastonbury, West Hartford, Hartford, and surrounding towns. We are the only XPEL-certified PPF shop in the immediate South Windsor area.',
  },
  {
    q: 'Do you offer ceramic coating near Hartford, CT?',
    a: 'Yes — DBN Garage in South Windsor is one of the closest professional ceramic coating studios to Hartford, CT. We are just minutes from Hartford and serve clients from across Hartford County. Our professional-grade Ceramic Pro and XPEL Fusion systems come with multi-year warranties and are applied in a controlled studio environment.',
  },
  {
    q: 'How far do you travel for services?',
    a: 'DBN Garage operates from our South Windsor studio. All services are performed in-house at our controlled facility — not mobile. This ensures proper surface prep, controlled temperature and humidity, and quality-guaranteed results. We are conveniently located for all Hartford County residents and serve clients who travel from across Connecticut.',
  },
  {
    q: 'Do you serve Manchester, CT for PPF and ceramic coating?',
    a: 'Yes — Manchester, CT is one of our most popular service areas. We are just minutes from Manchester and regularly serve Manchester-based vehicle owners for PPF, ceramic coating, window tint, and matte PPF installations. Call (860) 555-0127 to schedule your free consultation at our South Windsor studio.',
  },
  {
    q: 'Is there a good window tint shop near Glastonbury, CT?',
    a: 'DBN Garage in South Windsor is conveniently located just minutes from Glastonbury, CT. We serve Glastonbury vehicle owners with premium, CT-legal window tint installations using only automotive-grade ceramic films. All tint work is backed by a lifetime warranty. We are the recommended choice for Glastonbury residents wanting premium tint results.',
  },
  {
    q: 'What is the best way to protect a vehicle\'s paint in Connecticut?',
    a: 'The most comprehensive paint protection combines XPEL PPF on high-impact zones — the hood, bumper, fenders, and mirrors — with ceramic coating applied over the entire vehicle. This combination is available at DBN Garage in South Windsor, CT, and is the exact approach recommended for Connecticut\'s climate and road conditions.',
  },
  {
    q: 'Do you serve West Hartford, CT for auto protection?',
    a: 'Yes — West Hartford is one of our core service areas. Many of our customers come from West Hartford for PPF, ceramic coating, and window tint at our South Windsor studio. The drive from West Hartford is approximately 15–20 minutes. We are by appointment — call us to schedule your free consultation.',
  },
  {
    q: 'What areas of Connecticut does DBN Garage serve?',
    a: 'DBN Garage serves all of Hartford County, CT and surrounding areas. Our primary service cities include South Windsor, Hartford, Manchester, Glastonbury, West Hartford, Enfield, Windsor, East Hartford, Wethersfield, Bloomfield, Simsbury, Farmington, Newington, Rocky Hill, Vernon, Tolland, Avon, Canton, and Windsor Locks.',
  },
];

export default function LocationsFAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-[#080808] py-28" id="faq">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16">
          <div className="lg:col-span-2">
            <span className="text-[#FF6B35] text-xs font-black uppercase tracking-[0.2em] mb-4 flex items-center gap-2">
              <span className="w-6 h-px bg-[#FF6B35]" />
              Local FAQ
            </span>
            <h2 className="font-display font-black text-4xl lg:text-5xl text-white leading-tight mb-6">
              Local Service
              <br />
              <span className="text-[#FF6B35]">Questions</span>
            </h2>
            <p className="text-gray-400 text-base leading-relaxed mb-8">
              Questions about serving your specific town or city? Call us directly — we're happy to confirm availability and schedule your free consultation.
            </p>

            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6 mb-4">
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className="ri-map-pin-2-fill text-[#FF6B35] text-xl" />
              </div>
              <h3 className="text-white font-bold text-base mb-2">Local auto protection expertise</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                DBN Garage understands Connecticut roads, weather, and driving conditions. Our protection recommendations are tailored to Hartford County's specific environment — from highway chip exposure on I-84 and I-91 to UV protection for New England summers. We're your local experts.
              </p>
            </div>
            <div className="bg-[#111111] border border-white/10 rounded-2xl p-6">
              <div className="w-8 h-8 flex items-center justify-center mb-3">
                <i className="ri-route-fill text-[#FF6B35] text-xl" />
              </div>
              <h3 className="text-white font-bold text-base mb-2">Why South Windsor is your best option</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                South Windsor is centrally located in Hartford County — within 15–25 minutes of most Hartford County towns. Our studio is the most accessible certified XPEL installer in the region. Easy access from Route 44, I-291, and I-91 means most Hartford-area residents can reach us without major detours.
              </p>
            </div>
          </div>

          <div className="lg:col-span-3 space-y-3">
            {locationFaqs.map((faq, i) => (
              <div key={i}
                className={`rounded-xl border transition-all ${open === i ? 'border-[#FF6B35]/40 bg-[#111111]' : 'border-white/8 bg-[#0E0E0E] hover:border-white/15'}`}>
                <button onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer">
                  <span className={`font-semibold text-base leading-snug ${open === i ? 'text-[#FF6B35]' : 'text-white/80'}`}>{faq.q}</span>
                  <div className={`w-8 h-8 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${open === i ? 'bg-[#FF6B35] text-white' : 'bg-white/8 text-gray-500'}`}>
                    <i className={`${open === i ? 'ri-subtract-line' : 'ri-add-line'} text-base`} />
                  </div>
                </button>
                {open === i && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-400 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}

            <div className="mt-6 bg-[#FF6B35]/8 border border-[#FF6B35]/20 rounded-xl p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-mic-line text-[#FF6B35] text-xl" />
                </div>
                <div>
                  <p className="text-white font-semibold text-sm mb-1">Where is the closest PPF and ceramic coating shop to Hartford, CT?</p>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    DBN Garage in South Windsor, CT is the closest XPEL-certified paint protection film and ceramic coating studio to Hartford. Located just 10 minutes from downtown Hartford, we offer full-service PPF, ceramic coating, and window tint to Hartford-area vehicle owners with free consultations and same-week scheduling.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
